import { render, staticRenderFns } from "./fuzzySearch.vue?vue&type=template&id=54a4ad47&scoped=true"
import script from "./fuzzySearch.vue?vue&type=script&lang=ts"
export * from "./fuzzySearch.vue?vue&type=script&lang=ts"
import style0 from "./fuzzySearch.vue?vue&type=style&index=0&id=54a4ad47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4ad47",
  null
  
)

export default component.exports